/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarydownloadfailed3Inputs */

const en_medialibrarydownloadfailed3 = /** @type {(inputs: Medialibrarydownloadfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The download didn't work, so we opened the file instead.`)
};

const de_medialibrarydownloadfailed3 = /** @type {(inputs: Medialibrarydownloadfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Herunterladen hat nicht geklappt. Wir öffnen die Datei stattdessen.`)
};

/**
* | output |
* | --- |
* | "The download didn't work, so we opened the file instead." |
*
* @param {Medialibrarydownloadfailed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarydownloadfailed3 = /** @type {((inputs?: Medialibrarydownloadfailed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarydownloadfailed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarydownloadfailed3(inputs)
	return de_medialibrarydownloadfailed3(inputs)
});
export { medialibrarydownloadfailed3 as "mediaLibraryDownloadFailed" }